import React, { useState } from 'react'
import BookRate from 'tennders-transactions/views/common/BookRate'
import Company from 'tennders-transactions/views/common/Company'
import FindLoadButton from 'tennders-transactions/views/common/FindLoadButton'
import NotAssigned from 'tennders-transactions/views/common/NotAssigned'
import RefNumber from 'tennders-transactions/views/common/RefNumber'
import MPTag from 'tennders-transactions/views/common/TagMP'
import DeleteButton from 'tennders-transactions/views/common/DeleteButton'
import EditButton from 'tennders-transactions/views/common/EditButton'
import useSession from 'tennders-auth/hooks/useSession'
import { ItemTypes } from 'tennders-common/enums/ItemTypes'
import { LoadTruck } from 'tennders-common/enums/LoadTruck'
import CustomerRefNumber from 'tennders-transactions/views/common/CustomerRefNumber'
import useTranslation from 'next-translate/useTranslation'
import DOMPurify from 'dompurify'
import Trans from 'next-translate/Trans'
import GHref from 'tennders-market/common/components/element/GHref'
import { useToast } from 'tennders-common/hooks/useToast'
import { apiGet } from 'tennders-stracture/libs/api'
import { motion } from 'framer-motion'
import { STATUS_CANCELLED, TENNDERS_VAT_ID } from 'tennders-stracture/libs/constants'
import useInitials from 'tennders-common/hooks/useInitials'

const DetailedLoadView = ({ load, transaction, close }) => {
  const { isCarrierUser, isShipperUser, isBrokerUser, isMe } = useSession()
  const { t } = useTranslation()
  const { toastSuccess, toastError } = useToast()
  const [tracked, setTracked] = useState(false)
  const { boxOwner } = useInitials()

  const triggerTrack = async () => {
    setTracked(true)
    const res = await apiGet(`transactions/${transaction?.matchedTruck?.transactionId}/track`)
    setTracked(false)
    if (res.error) {
      toastError(res.error)
    } else {
      toastSuccess(t('offer:trackMsgForBroker'))
    }
  }

  return (
    <div style={{ overflow: 'hidden' }} className="w-50">
      <motion.div initial={{ opacity: 0, y: 200 }} animate={{ opacity: 1, y: 0 }} transition={{ ease: [0.13, 0.64, 0.47, 1], duration: 0.1, delay: 0.15 }} className="pr-10">
        <div
          className="d-flex column justify-space align-center border-b pb-8 mb-8"
          style={(transaction?.matchedTruck || transaction?.matchedLoad) && isBrokerUser ? { height: 78 } : null}
        >
          <div className="d-flex justify-space align-center w-100" style={{ height: 24 }}>
            <h3 className="d-flex w-100 bold mb-0">{t('transaction:loadInformation')}</h3>
            {(load && !isCarrierUser) && (
              <>
                { !transaction.disabledActions.includes('EDIT_LOAD') && !(boxOwner?.nif === TENNDERS_VAT_ID && transaction?.isMarketPlaced) && (
                  <EditButton transaction={transaction} type={ItemTypes.LOAD} board="transactionDetail" close={close} />
                )}
                <div className="pr-10" />
                {transaction?.isMatched && transaction?.matchedTruck?.isMarketPlaced && transaction.status.label !== STATUS_CANCELLED
                  && (!isCarrierUser && !isShipperUser) && (
                  <GHref
                    onClick={triggerTrack}
                    className="btn-border standard-btn small mr-10  tennders-counter-btn"
                    submitting={tracked}
                  >
                    <Trans i18nKey="offer:track" />
                  </GHref>
                )}
                <DeleteButton
                  transaction={transaction}
                  type={ItemTypes.LOAD}
                  isDeleteButton
                  board="transactionDetail"
                  closeTransaction={close}
                />
              </>
            )}
          </div>
          {transaction && isBrokerUser && (
            transaction?.isMarketPlaced
              ? (
                <div className="d-flex justify-space align-center w-100 mt-10 mb-10">
                  <MPTag />
                </div>
              )
              : transaction?.matchedLoad
                ? (
                  <div className="d-flex justify-space align-center w-100 mt-10 mb-10">
                    <span className={'text-12 lh-1 p-6 t-state-text ' + (transaction?.matchedLoad?.internalOwner ? 'is-internal' : 'is-external')}>
                      #{t('transaction:' + (transaction?.matchedLoad?.internalOwner ? 'internal' : 'external'))}
                    </span>
                  </div>
                )
                : null
          )}
        </div>
        {!load ? (
          <>
            <NotAssigned />
            {transaction.isOpenToQC ? <FindLoadButton transaction={transaction} withIcon={false} /> : null}
          </>
        ) : (
          <>
            <div className="d-flex mb-10">
              <div className="w-auto">
                <img src="/icons/icon-load-info.svg" alt={t('transaction:loadInformation')} width="40" />
              </div>
              <Company documentType="INVOICE" {...load} />
            </div>
            {load?.pointOfContact ? <><span className="bold" style={{ fontSize: 13 }}>{t('transaction:poc')}:</span> {load.pointOfContact?.name}</> : null}
            <div
              className="text-12 mb-10"
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(load?.allDetails?.replace(/\n/g, '<br/>')) }}
            />
            {(isBrokerUser || isMe(transaction?.matchedLoad?.createdBy)) && (
              <BookRate {...load} transaction={transaction} isAbout={LoadTruck.load} />
            )}
            <RefNumber {...load} />
            {!isCarrierUser && load?.customerReferenceNumber && <CustomerRefNumber cRefNumber={load?.customerReferenceNumber} />}
          </>
        )}
      </motion.div>
    </div>
  )
}

export default React.memo(DetailedLoadView)
